export enum ActionType {
  AWARD_DECISION = "AWARD_DECISION",
  QUOTING_CLOSING = "QUOTING_CLOSING",
  CONSULTATION_ENDING = "CONSULTATION_ENDING",
  NEVER_LAUNCHED = "NEVER_LAUNCHED",
  DELIVERY_UNCONFIRMED = "DELIVERY_UNCONFIRMED",
  UNASSIGNED = "UNASSIGNED",
  STALLED_CREATED = "STALLED_CREATED",
  TEAM_AWARD_OVERDUE = "TEAM_AWARD_OVERDUE",
  TEAM_NO_BIDS = "TEAM_NO_BIDS",
}

export enum EntityKind {
  ORDER = "ORDER",
  PURCHASE_REQUEST = "PURCHASE_REQUEST",
  DELIVERY = "DELIVERY",
}

export enum Urgency {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export interface ActionItem {
  type: ActionType;
  entityId: string;
  entityKind: EntityKind;
  reference: string;
  subject: string;
  urgency: Urgency;
  /** ISO-8601, or null when the row is ranked by age instead. */
  dueAt: string | null;
  ageDays: number;
  offerCount: number | null;
  assignee: string | null;
  /** The joint (MultipleOrder) this order belongs to, or null for a simple order / non-order item.
   * Present so a joint row routes to the joint view instead of a single constituent order. */
  multipleOrderId: string | null;
}

export interface PulseCounts {
  rfqsPendingAward: number;
  openRfqs: number;
  scheduledRfqs: number;
  requestsInProcess: number;
  pendingDelivery: number;
}

export interface TeamAttention {
  items: ActionItem[];
  /** Uncapped, so the UI can offer "see all {total}". */
  total: number;
}

export interface ManagerDashboardResponse {
  pulse: PulseCounts;
  needsYou: ActionItem[];
  teamAttention: TeamAttention;
  degraded: ActionType[];
}
